import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '@/components/AdminLayout'
import EventForm from '@/components/EventForm'

type Props = {
  dress_codes: string[]
  causes: string[]
}

export default function AdminEventsNew({ dress_codes, causes }: Props) {
  return (
    <>
      <Head title="Admin - New Seeded Event" />
      <EventForm dressCodes={dress_codes} causes={causes} actionUrl="/admin/events" isAdmin />
    </>
  )
}

AdminEventsNew.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>
